import { createSlice } from "@reduxjs/toolkit";

const initial_state = {
  adminToken: null,
  adminData: {},
  isAdminLoggedIn: false,
  loading: false,
  loadingType: "default",
  isError: false,
  errorTitle: "Error",
  errorMessage: "Something went wrong",
  isSuccessModal: false,
  successTitle: "Success",
  successMessage: "Operation completed successfully",
  loginSuccess: false,
  logoutSuccess: false,
  registerSuccess: false,
  forgotPasswordSuccess: false,
  resetPasswordSuccess: false,
  permissions: [],
  role: null,
};

const adminAuthSlice = createSlice({
  name: "ADMIN_AUTH",
  initialState: initial_state,
  reducers: {
    updateAdminAuth: (state, { payload }) => {
      return { ...state, ...payload };
    },
    adminLogout: (state, action) => {
      state = initial_state;
      return state;
    },
    setAdminPermissions: (state, { payload }) => {
      state.permissions = payload;
    },
    setAdminRole: (state, { payload }) => {
      state.role = payload;
    },

  },
});

export const { updateAdminAuth, adminLogout, setAdminPermissions, setAdminRole, } = adminAuthSlice.actions;
export default adminAuthSlice.reducer;
